var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid main-content"},[_c('div',{staticClass:"main-panel"},[_c('div',{class:'content-wrapper ' + _vm.paddingClass},[_c('div',{staticClass:"inner-div container-fluid"},[_c('router-view')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }